export const QAS_REQUIRED_FIELD_HIDDEN_GROUP_MAPS = {
  Food: ['Components', 'Pet Food'],
  'HBC / OTC': ['Ingredients', 'Pet Food'],
  'Fresh - Deli': ['Components', 'Pet Food'],
  'Fresh - Meat': ['Components', 'Pet Food'],
  'Fresh - Seafood': ['Components', 'Pet Food'],
  'Fresh - Produce': ['Components', 'Pet Food'],
  'Non-Food': ['Ingredients', 'Facts Panel', 'Pet Food'],
  // Pet: ['Claims'],
};

export const QAS_REQUIRED_FIELD_ADDITIONAL_GROUP_MAPS = {
  'Fresh - Deli': ['Fresh - Deli'],
  'Fresh - Meat': ['Fresh - Meat'],
  'Fresh - Produce': ['Fresh - Produce'],
  'Fresh - Seafood': ['Fresh - Seafood'],
  Pet: ['Pet Food'],
};

export const QAS_REQUIRED_FIELD_HIDDEN_FIELDS_MAPS = {
  'HBC / OTC': [
    'qaSpecification.formulaActiveIngredients',
    'qaSpecification.formulaInactiveIngredients',
    'qaSpecification.formulaIngredientsPurposeStrength',
    'qaSpecification.formulaOtherIngredients',
  ],
};

export const QAS_REQUIRED_FIELD_ONLY_SHOW_GROUP_MAPS = [
  {
    productType: 'Non-Food',
    groupNames: {
      'Product Specification': {
        groupNames: {
          'Organoleptic Characteristics': {
            groupNames: {
              'Workmanship': null,
              'Function': null,
            },
          },
        },
      },
    },
  },
];
